import { State } from 'xstate';
import { billingHistoryData } from './billingHistoryData';

export type CustomerDataMachine = typeof billingHistoryData;
export type CustomerDataState = State<CustomerDataMachine['context']>;

export const getBillingHistoryData = (machineState: CustomerDataState) => ({
  items: machineState.context.items,
  sorting: machineState.context.sorting,
  pagination: machineState.context.pagination,
  filters: machineState.context.filters,
});

export const getBillingHistoryState = (machineState: CustomerDataState) => ({
  isLoading: machineState.matches('apiClient.loading'),
  isFiltering:
    machineState.context.filters &&
    Object.values(machineState.context.filters).some(
      (value) => value && value.length > 0
    ),
});

export const getBillingItemById =
  (itemId: string) => (machineState: CustomerDataMachine) =>
    machineState.context.items.filter((item) => item.id === itemId);

export const billingHistorySelectors = {
  getBillingHistoryData,
  getBillingHistoryState,
  getBillingItemById,
};
